module.exports = __webpack_public_path__ + "img/sld_scb_5_t1_dark.3173cac2.svg";